module.exports = __webpack_public_path__ + "img/service5.f1888e8d.png";